/**
 * Created by DELL on 2018/4/16.
 */
import { handleActions } from 'redux-actions'
import * as types from '../constants/ActionTypes'

const reducers = {}
const initialState = {
    list:[],
    count:'',
    pageIndex:1,
    pageSize:10,
}

reducers[types.SAFETY_MECHANISM_LIST]=(state,action)=>{

    if(!action.error){
        return Object.assign({}, state, {list: action.payload.list,count:action.payload.count,pageIndex:action.payload.pageIndex,pageSize:action.payload.pageSize, province:action.payload.province,
            city:action.payload.city})
    }


}

export default handleActions(reducers,initialState)